import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Filter, PlusCircle } from "react-feather";
import Select from "react-select";
import ImageWithBasePath from "../../core/img/imagewithbasebath";
import Swal from "sweetalert2";
import axios from "axios";
import Table from "../../core/pagination/datatable";
import {
  API_BASE_URL,
  GET_EXPENSE,
  GET_EXPENSE_TYPE,
  GET_SUPPLIERS,
  GET_USER_STORES,
} from "../../Config";
import AddExpenses from "./AddExpenses";
import SpinLoader from "../loader/SpinLoader";
// import SpinLoader from "../loader/SpinLoader";
import EditExpense from "./EditExpense";
import jsPDF from "jspdf";
import "jspdf-autotable";
import * as XLSX from "xlsx";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import ViewExpense from "./ViewExpense";

const ExpensesList = () => {
  const [userDataSession, setUserDataSession] = useState(null);
  const [expenses, setExpenses] = useState([]);
  const [storeData, setStoreData] = useState([]);
  const [supplierData, setSupplierData] = useState([]);
  const [selectedStore, setSelectedStore] = useState(null);
  const [selectedSupplier, setSelectedSupplier] = useState(null);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [loading, setLoading] = useState(false);
  const [isFilterVisible, setIsFilterVisible] = useState(true);
  const [editExpensedata, setEditExpenseData] = useState([]);
  const [showEditOffcanvas, setShowEditOffcanvas] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [isAddOffcanvasOpen, setIsAddOffcanvasOpen] = useState(false);
  const [showViewOffcanvas, setShowViewOffcanvas] = useState(false);
  // const [viewExpenseId, setViewExpenseId] = useState(null);
  const [viewExpenseRecord, setViewExpenseRecord] = useState(null);
  useEffect(() => {
    const userDataString = sessionStorage.getItem("userData");
    if (userDataString) {
      const userData = JSON.parse(userDataString);
      setUserDataSession(userData);
    }
  }, []);

  const handleEditClick = (record) => {
    setEditExpenseData(record);
    setShowEditOffcanvas(true);
  };

  const handleViewClick = (record) => {
    // setViewExpenseId(record.Id);
    setViewExpenseRecord(record);
    setShowViewOffcanvas(true);
  };

  function downloadBlob(blob, fileName) {
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = fileName;
    link.style.display = "none";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  }

  const exportToPDF = () => {
    if (expenses.length === 0) {
      Swal.fire("No Data", "Nothing to export", "info");
      return;
    }

    const doc = new jsPDF("landscape", "pt", "a4");

    // Header
    doc.setFontSize(16);
    doc.text("Expenses List", 40, 30);
    doc.setFontSize(10);
    doc.text(
      `Generated on: ${new Date().toLocaleString()} | Total: ${expenses.length}`,
      40,
      50,
    );

    // Columns (match your table – skip Action column)
    const exportColumns = columns
      .filter((col) => col.title !== "Action")
      .map((col) => col.title);

    // Rows – prepare data with same rendering logic
    const exportData = expenses.map((record) => [
      record.ReferenceNo || "-",
      record.StoreName || "N/A",
      record.SupplierName || "N/A",
      record.SupplierContact || "N/A",
      parseFloat(record.Amount || 0).toFixed(2),
      parseFloat(record.PaidAmount || 0).toFixed(2),
      parseFloat(record.DueAmount || 0).toFixed(2),
      record.Note || "-", // or full note if short
      (() => {
        const isCompleted =
          record.Status === 1 && Number(record.DueAmount) === 0;
        return isCompleted ? "Completed" : "Pending";
      })(),
      record.DateOfTransaction
        ? new Date(record.DateOfTransaction).toLocaleDateString("en-GB")
        : "-",
    ]);

    doc.autoTable({
      head: [exportColumns],
      body: exportData,
      startY: 65,
      theme: "grid",
      styles: { fontSize: 9, cellPadding: 6, overflow: "linebreak" },
      headStyles: {
        fillColor: [44, 62, 80],
        textColor: [255, 255, 255],
        fontStyle: "bold",
      },
      alternateRowStyles: { fillColor: [240, 240, 240] },
      margin: { top: 65, left: 40, right: 40 },
    });

    doc.save(`Expenses_${new Date().toISOString().split("T")[0]}.pdf`);
  };

  const exportToExcel = () => {
    if (expenses.length === 0) {
      Swal.fire("No Data", "Nothing to export", "info");
      return;
    }

    const exportData = expenses.map((record) => ({
      "Ref No": record.ReferenceNo || "-",
      Store: record.StoreName || "N/A",
      Supplier: record.SupplierName || "N/A",
      Contact: record.SupplierContact || "N/A",
      Total: parseFloat(record.Amount || 0).toFixed(2),
      Paid: parseFloat(record.PaidAmount || 0).toFixed(2),
      Due: parseFloat(record.DueAmount || 0).toFixed(2),
      Note: record.Note || "-",
      Status:
        record.Status === 1 && Number(record.DueAmount) === 0
          ? "Completed"
          : "Pending",
      "Last Paid On": record.DateOfTransaction
        ? new Date(record.DateOfTransaction).toLocaleDateString("en-GB")
        : "-",
    }));

    const ws = XLSX.utils.json_to_sheet(exportData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Expenses");

    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const dataBlob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
    });

    downloadBlob(
      dataBlob,
      `Expenses_${new Date().toISOString().split("T")[0]}.xlsx`,
    );
  };

  const renderPdfTooltip = (props) => (
    <Tooltip id="pdf-tooltip" {...props}>
      PDF
    </Tooltip>
  );

  const renderExcelTooltip = (props) => (
    <Tooltip id="excel-tooltip" {...props}>
      Excel
    </Tooltip>
  );

  // const renderRefreshTooltip = props => (
  //   <Tooltip id="refresh-tooltip" {...props}>Refresh</Tooltip>
  // );
  useEffect(() => {
    if (!userDataSession?.OrgId || !userDataSession?.UserId) return;

    const fetchDropdowns = async () => {
      try {
        // Stores
        const storeRes = await axios.get(
          `${API_BASE_URL}${GET_USER_STORES}?UserId=${userDataSession.UserId}`,
        );
        if (storeRes.data?.Status) {
          setStoreData(storeRes.data.ResultData);
        }

        // Suppliers
        const supRes = await axios.get(
          `${API_BASE_URL}${GET_SUPPLIERS}/${userDataSession.OrgId}`,
        );
        if (supRes.data?.Status) {
          setSupplierData(supRes.data.ResultData);
        }

        // Expense Types (only for add modal)
        await axios.get(
          `${API_BASE_URL}${GET_EXPENSE_TYPE}?OrgId=${userDataSession.OrgId}`,
        );
        // No need to store in state if not used in list view
      } catch (err) {
        console.error("Dropdown fetch error:", err);
      }
    };

    fetchDropdowns();
  }, [userDataSession?.OrgId]);

  // Initial fetch of all expenses
  // Initial load: fetch all expenses when user session is ready
  useEffect(() => {
    if (userDataSession?.OrgId) {
      handleSearch();
    }
  }, [userDataSession?.OrgId]);
  const handleExpenseAdded = () => {
    handleSearch(); // refresh the list
  };
  const toggleFilter = () => setIsFilterVisible(!isFilterVisible);

  const handleSearch = async () => {
    setLoading(true);

    const payload = {
      OrgId: userDataSession.OrgId,
      StartDate: startDate || "2000-01-01",
      EndDate: endDate || "2099-12-31",
      StoreId: selectedStore?.value || 0,
      SupplierId: selectedSupplier?.value || 0,
    };

    try {
      const res = await axios.post(`${API_BASE_URL}${GET_EXPENSE}`, payload);
      if (res.data.Status) {
        setExpenses(res.data.ResultData || []);
      } else {
        setExpenses([]);
      }
    } catch (err) {
      console.error("Fetch error:", err);
      // Swal.fire("Error", "Failed to load expenses", "error");
    } finally {
      setLoading(false);
    }
  };
  const getStatusInfo = (record) => {
    const due = Number(record.DueAmount || 0);
    const paid = Number(record.PaidAmount || 0);
    // const status = record.Status; // assuming 1 = approved/valid, 0 = draft/rejected/etc.

    if (due > 0 && paid > 0) {
      return {
        label: "partially-paid",
        className: "bg-primary",
        iconClass: "text-primary",
      };
    }

    if (due === 0 && paid > 0) {
      return {
        label: "Completed",
        className: "bg-success",
        iconClass: "text-success",
      };
    }

    if (paid === 0 && due > 0) {
      return {
        label: "Not Paid",
        className: "bg-danger",
        iconClass: "text-danger",
      };
    }

 
    return {
      label: "Pending",
      className: "bg-warning",
      iconClass: "text-warning",
    };
  };

  const truncateText = (text, maxLength = 13) => {
    if (!text) return "N/A";
    if (text.length <= maxLength) return text;
    return <span title={text}>{text.substring(0, maxLength)}...</span>;
  };
  const columns = [
    {
      title: "Ref No",
      dataIndex: "ReferenceNo",
      key: "ReferenceNo",
    },
    {
      title: "Store ",
      dataIndex: "StoreName",
      key: "StoreName",
      // render: (text) => text || "N/A",
      render: (text) => truncateText(text, 13),
    },
    {
      title: "Supplier ",
      dataIndex: "SupplierName",
      key: "SupplierName",
      // render: (text) => text || "N/A",
      render: (text) => truncateText(text, 13),
    },
    {
      title: "Contact",
      dataIndex: "SupplierContact",
      key: "SupplierContact",
      render: (text) => truncateText(text, 13),
    },
    {
      title: "Total",
      dataIndex: "Amount",
      key: "Amount",
      sorter: (a, b) => a.Amount - b.Amount,
    },
    {
      title: "Paid ",
      dataIndex: "PaidAmount",
      key: "PaidAmount",
    },
    {
      title: "Due ",
      dataIndex: "DueAmount",
      key: "DueAmount",
    },
    {
      title: "Note",
      dataIndex: "Note",
      key: "Note",
      width: 80,
      align: "center",
      render: (notes) =>
        (
          <span title={notes}>
            <i className="fa-regular fa-message"></i>
          </span>
        ) || "N/A",
    },
    {
      title: "Status",
      dataIndex: "Status",
      key: "Status",
      width: 110,
      align: "center",
      render: (_, record) => {
        const info = getStatusInfo(record);

        return (
          <div title={info.label}>
            <i className={`fa-solid fa-circle fs-5 ${info.iconClass}`} />
          </div>
        );
      },
    },
    {
      title: "Last Paid On",
      dataIndex: "PaidDate",
      key: "PaidDate",
      render: (date) =>
        date ? new Date(date).toLocaleDateString("en-GB") : "-",
      sorter: (a, b) => new Date(a.PaidDate) - new Date(b.PaidDate),
    },
    {
      title: "Action",
      key: "action",
      width: 120,
      render: (_, record) => (
        <td className="action-table-data">
          <div className="edit-delete-action">
            <Link
              className="me-2 p-2 mb-0"
              onClick={() => handleViewClick(record)}
              title="View Expense"
            >
              <i data-feather="eye" className="feather-eye" />
            </Link>
            <Link
              className="me-2 p-2 mb-0"
              title="Add Expense"
              // data-bs-toggle="offcanvas"
              // data-bs-target="#offcanvasEditExpense"
              onClick={() => handleEditClick(record)}
            >
              <i className="fa-solid fa-indian-rupee-sign"></i>

              {/* <i data-feather="edit" className="feather-edit" /> */}
            </Link>

            {/* <Link
            className="me-2 p-2 mb-0"
            data-bs-toggle="offcanvas"
            data-bs-target="#offcanvasEditExpense"
          >
            <i data-feather="edit" className="feather-edit" />
          </Link> */}
            <Link className="confirm-text p-2 mb-0 d-none">
              <i data-feather="trash-2" className="feather-trash-2" />
            </Link>
          </div>
        </td>
      ),
    },
  ];
  console.log(loading, "loading");

  const filteredData = expenses.filter((item) => {
    const searchLower = searchText.toLowerCase();
    return (
      (item.ReferenceNo &&
        item.ReferenceNo.toLowerCase().includes(searchLower)) ||
      (item.StoreName && item.StoreName.toLowerCase().includes(searchLower)) ||
      (item.SupplierName &&
        item.SupplierName.toLowerCase().includes(searchLower))
    );
  });

  return (
    <>
      {loading && <SpinLoader />}
      {/* {loading && <SpinLoader />} */}
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Expense List</h4>
                <h6>Manage Your Expenses</h6>
              </div>
            </div>
            <ul className="table-top-head">
              {/* Existing refresh or other icons if any */}

              <li>
                <OverlayTrigger placement="top" overlay={renderPdfTooltip}>
                  <Link onClick={exportToPDF}>
                    <ImageWithBasePath
                      src="assets/img/icons/pdf.svg"
                      alt="pdf"
                    />
                  </Link>
                </OverlayTrigger>
              </li>

              <li>
                <OverlayTrigger placement="top" overlay={renderExcelTooltip}>
                  <Link onClick={exportToExcel}>
                    <ImageWithBasePath
                      src="assets/img/icons/excel.svg"
                      alt="excel"
                    />
                  </Link>
                </OverlayTrigger>
              </li>

              {/* Optional: Refresh button if you want */}
              {/* <li>
    <OverlayTrigger placement="top" overlay={renderRefreshTooltip}>
      <Link onClick={handleSearch}>
        <RotateCcw />
      </Link>
    </OverlayTrigger>
  </li> */}
            </ul>

            <div className="page-btn">
              <button
                className="btn btn-added"
                onClick={() => setIsAddOffcanvasOpen(true)}
                // data-bs-toggle="offcanvas"
                // data-bs-target="#offcanvasAddExpense"
              >
                <PlusCircle className="me-2" /> Add Expense
              </button>
            </div>
          </div>

          <div className="card table-list-card">
            <div className="card-body">
              <div className="table-top">
                <div className="search-set">
                  <div className="search-input">
                    <input
                      type="text"
                      placeholder="Search"
                      value={searchText}
                      onChange={(e) => setSearchText(e.target.value)}
                      className="form-control form-control-sm"
                    />
                    <Link className="btn btn-searchset">
                      <i data-feather="search" />
                    </Link>
                  </div>
                </div>
                <div className="search-path">
                  <Link
                    className={`btn btn-filter ${isFilterVisible ? "setclose" : ""}`}
                    onClick={toggleFilter}
                  >
                    <Filter className="filter-icon" />
                    <span>
                      <ImageWithBasePath
                        src="assets/img/icons/closes.svg"
                        alt="close"
                      />
                    </span>
                  </Link>
                </div>
              </div>

              {/* Filter Section */}
              <div
                className={`card ${isFilterVisible ? "visible" : ""}`}
                id="filter_inputs"
                style={{ display: isFilterVisible ? "block" : "none" }}
              >
                <div className="card-body pb-0">
                  <div className="row g-3">
                    {/* Store */}
                    <div className="col-lg-2 col-sm-6 col-12">
                      <Select
                        placeholder="Select Store"
                        value={selectedStore}
                        onChange={setSelectedStore}
                        options={storeData.map((s) => ({
                          value: s.StoreId,
                          label: s.Name,
                        }))}
                        isClearable
                      />
                    </div>

                    {/* Supplier */}
                    <div className="col-lg-2 col-sm-6 col-12">
                      <Select
                        placeholder="Select Supplier"
                        value={selectedSupplier}
                        onChange={setSelectedSupplier}
                        options={supplierData.map((s) => ({
                          value: s.Id,
                          label: s.SupplierName,
                        }))}
                        isClearable
                      />
                    </div>

                    {/* Start Date */}
                    <div className="col-lg-2 col-sm-6 col-12">
                      <div className="input-blocks">
                        <input
                          type="date"
                          className="form-control"
                          value={startDate}
                          onChange={(e) => setStartDate(e.target.value)}
                        />
                      </div>
                    </div>

                    {/* End Date */}
                    <div className="col-lg-2 col-sm-6 col-12">
                      <div className="input-blocks">
                        <input
                          type="date"
                          className="form-control"
                          value={endDate}
                          onChange={(e) => setEndDate(e.target.value)}
                        />
                      </div>
                    </div>

                    <div className="col-lg-2 col-sm-12 col-12 mt-3 text-end">
                      <button
                        className="btn btn-primary"
                        onClick={handleSearch}
                        disabled={loading}
                      >
                        {loading ? "Searching..." : "Search"}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              {/* Ant Design Table */}
              <div className="table-responsive">
                <Table
                  columns={columns}
                  dataSource={filteredData}
                  rowKey="Id"
                  pagination={{ pageSize: 10, showSizeChanger: true }}
                  loading={loading}
                  locale={{ emptyText: "No expenses found" }}
                  scroll={{ x: "max-content" }}
                />
              </div>
            </div>
          </div>
        </div>

        <AddExpenses
          isOpen={isAddOffcanvasOpen}
          onClose={() => setIsAddOffcanvasOpen(false)}
          onExpenseAdded={handleExpenseAdded}
        />

        {/* {showEditOffcanvas && editExpenseId && ( */}
        <EditExpense
          show={showEditOffcanvas}
          expense={editExpensedata}
          onSuccess={() => {
            setShowEditOffcanvas(false);
            handleSearch();
          }}
          onClose={() => setShowEditOffcanvas(false)}
        />
      </div>

      <ViewExpense
        show={showViewOffcanvas}
        // expenseId={viewExpenseId}
        expense={viewExpenseRecord}
        orgId={userDataSession?.OrgId}
        onClose={() => {
          setShowViewOffcanvas(false);
          setViewExpenseRecord(null);
        }}
      />
    </>
  );
};

export default ExpensesList;
